module.exports = __webpack_public_path__ + "static/img/prof-services-300x300.74caf8fd.jpg";